import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { getUser } from '../features/authentication/utils/auth';
import HomeContainer from '../features/home/components/HomeContainer';
import {
	getSkills,
	getSectors,
	getResources,
	canUserEditPlanning,
} from '../features/planning/utils/calendar';
import { useLocalStorage } from '../hooks';

const Home = ({ currentTab = 'activities' }) => {
	const { roles = [] } = getUser();
	const [loading, isLoading] = useState(false);
	const [error, setError] = useState(false);
	const [skills, saveSkills] = useLocalStorage(
		`${process.env.REACT_APP_BASE_NAME}_skills`,
		[],
	);

	const [sectors, saveSectors] = useLocalStorage(
		`${process.env.REACT_APP_BASE_NAME}_sectors`,
		[],
	);

	const [resources, saveResources] = useLocalStorage(
		`${process.env.REACT_APP_BASE_NAME}_resources`,
		[],
	);

	const [refreshData, setRefreshData] = useState(false);
	const [changeFiliale, setChangeFiliale] = useState(null);

	const [canEditPlanning, setCanEditPlanning] = useState(false);

	useEffect(() => {
		async function fetchCanEdit() {
			const canEdit = await canUserEditPlanning();
			setCanEditPlanning(canEdit);
		}

		fetchCanEdit();
	}, []);

	useEffect(() => {
		const fetchData = async () => {
			isLoading(true);
			const res = await getResources();

			if (res?.length > 0) {
				if (res?.length > 0) {
					saveResources(res);
				} else {
					setError(true);
				}
				if (
					roles?.length > 0 &&
					roles.includes('ROLE_CUISINE_INTERNE') &&
					skills?.length === 0 &&
					!error
				) {
					const resSkills = await getSkills();
					if (resSkills?.length > 0) {
						saveSkills(resSkills);
					} else {
						setError(true);
					}
				}

				if (
					roles?.length > 0 &&
					roles.includes('ROLE_CUISINE_INTERNE') &&
					sectors?.length === 0 &&
					!error
				) {
					const resSectors = await getSectors();
					if (resSectors?.length > 0) {
						saveSectors(resSectors);
					} else {
						setError(true);
					}
				}
				isLoading(false);
				return true;
			}
			isLoading(false);
			// setError(true);
			return true;
		};

		if (
			(resources?.length === 0 && !error && !loading) ||
			// eslint-disable-next-line eqeqeq
			(changeFiliale && !loading)
		) {
			fetchData();
			setChangeFiliale(null);
		}
	}, [skills, sectors, resources]);

	const refreshUserPermissions = async () => {
		const canEdit = await canUserEditPlanning();
		setCanEditPlanning(canEdit);
	};

	const refreshFilter = async () => {
		isLoading(true);
		const res = await getResources();

		if (res?.length > 0) {
			if (res?.length > 0) {
				saveResources(res);
			} else {
				setError(true);
			}
			if (
				roles?.length > 0 &&
				roles.includes('ROLE_CUISINE_INTERNE') &&
				!error
			) {
				const resSkills = await getSkills();
				if (resSkills?.length > 0) {
					saveSkills(resSkills);
				} else {
					setError(true);
				}
			}

			if (
				roles?.length > 0 &&
				roles.includes('ROLE_CUISINE_INTERNE') &&
				!error
			) {
				const resSectors = await getSectors();
				if (resSectors?.length > 0) {
					saveSectors(resSectors);
				} else {
					setError(true);
				}
			}
			isLoading(false);
			return true;
		}
		isLoading(false);
		// setError(true);
		return true;
	};

	useEffect(() => {
		if (refreshData) {
			refreshFilter();
			setRefreshData(false);
			setChangeFiliale(null);
			refreshUserPermissions();
		}
	}, [refreshData]);

	// if (error) return null;
	if (roles?.length > 0 && roles.includes('ROLE_CUISINE_INTERNE')) {
		// if (skills?.length === 0 || sectors?.length === 0) return null;
	}
	// if (resources?.length === 0) return null;

	return (
		<HomeContainer
			currentTab={currentTab}
			sectors={sectors}
			skills={skills}
			resources={resources}
			changeFiliale={changeFiliale}
			setChangeFiliale={setChangeFiliale}
			setRefreshData={setRefreshData}
			refreshData={refreshData}
			canEditPlanning={canEditPlanning}
		/>
	);
};

Home.propTypes = {
	currentTab: PropTypes.string,
};

export default Home;
